import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { NotificationService } from 'src/app/services/notification.service';
import { finalize } from 'rxjs';
import { helper } from 'src/environments/helper';
import { SpecializariService } from '../specializari.service';
import { Specializare } from '../specializari.interface';

@Component({
    selector: 'app-add-specializari',
    templateUrl: './add-specializari.component.html',
    styleUrls: ['./add-specializari.component.scss']
})
export class AddSpecializariComponent {
    // general error
    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;
    helper = helper;

    token!: string;
    isLoading = false;

    form: FormGroup = new FormGroup({
        name: new FormControl('', Validators.required),
    });

    constructor(
        private dialogRef: MatDialogRef<AddSpecializariComponent>,
        private specializariService: SpecializariService,
        private notificationService: NotificationService,
    ) { }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    submitForm() {
        this.isLoading = true;

        const { name } = this.form.value as Specializare;

        const newSpecializare: Specializare = {
            name,
        };

        this.specializariService
            .add(newSpecializare)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: (res) => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }
}
